import cn from 'classnames';
import styles from './livelabel.module.sass';

export type LiveLabelKind = 'live' | 'rewind';

export interface LiveLabelProps {
    kind: LiveLabelKind;
    text?: string;
    className?: string;
}

/** Figma "LiveTV Labels/M"; needs a positioned parent */
export const LiveLabel = ({ kind, text, className }: LiveLabelProps) => (
    <span className={cn(styles.label, kind === 'rewind' && styles.rewind, className)}>
        {kind === 'live' && <span className={styles.dot} />}
        {text ?? kind}
    </span>
);
